import React from 'react';

import PackagingImg from "../assets/img/halalfull-packaging.png";
const Packaging = () => {
  return (
    <section className="bg-gray-50 py-20 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Image with Animation */}
          <div className="flex justify-center lg:justify-start">
            <div className="relative group">
              <img
                src={PackagingImg}
                alt="Halal Full Packaging"
                className="relative w-full max-w-lg rounded-lg  transform transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </div>

          {/* Right Side - Content with Fade In */}
          <div className="space-y-12">
            {/* Mission Section */}
            <div className="animate-fadeIn">
              <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-6 tracking-tight">
                Mission
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                Customers often face the issue of spillage from the meat they buy
                from the traditional next door butcher shops and require a round of
                cleaning and packaging before they are cooked or stored.
              </p>
            </div>

            {/* Vision Section */}
            <div className="animate-fadeIn animation-delay-200">
              <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-6 tracking-tight">
                Vision
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                Halalfull delivers meat in a high quality multiple layers of packaging
                to avoid spillage and for easy storage. You are just one step away
                from start cooking or storing
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Packaging;
